import axios from '../utils/axios'

export function GameInstruction(params) {
  return axios.post('game/instruction', params);
}
